import React from 'react';

const Phone = props => (
  <svg viewBox="0 0 500 870" width="500" height="870" {...props}>
    <path
      className="st0"
      d="M458.2 0H41.8C18.7 0 0 18.8 0 41.9v.1h500v-.1C500 18.8 481.3 0 458.2 0zM41.8 870h416.5c23.1 0 41.8-18 41.8-42H0c0 24 18.7 42 41.8 42zM0 42h5v786H0zM495 42h5v786h-5z"
    />
  </svg>
);

export default Phone;



// WEBPACK FOOTER //
// ./src/components/modules/Icons/phone.js